import React, { useState } from 'react';
import './index.css';
import QueueAnim from 'rc-queue-anim';
import clsx from 'classnames';
import { Link, useLocation } from 'react-router-dom';
import { getPageList } from '../config';
import { useAppContext } from '../../context/AppContext';

const Header = () => {
  const [show, setShow] = useState(false);
  const { pathname } = useLocation();
  const pageList = getPageList(pathname);
  const {
    state: { click },
    dispatch,
  } = useAppContext();

  const onClick = (value) => {
    setShow(!show);
    if (value.special && typeof click === 'function') {
      click();
    }
  };

  const onLinkClick = (value) => {
    dispatch({
      type: 'SET_NEWS_CURRENT_PAGE',
      payload: 1,
    });
    dispatch({
      type: 'SET_QUERY_RESULT_STATUS',
      payload: false,
    });
    if (value.special && typeof click === 'function') {
      click();
    }
  };

  const onPath = () => {
    dispatch({
      type: 'SET_NEWS_CURRENT_PAGE',
      payload: 1,
    });
    setShow(!show);
  };

  return (
    <div className={clsx('header')}>
      <div className={clsx('navbar')}>
        <div className={clsx('container')}>
          <div className={clsx('navbar-header', { show: show })}>
            <Link to='/'>
              <img
                src='/images/logo.png'
                alt=''
                width='60%'
                height='100%'
                style={{ marginLeft: '15px', paddingTop: '4px' }}
              />
            </Link>
            <button
              type='button'
              className={clsx('navbar-toggle', { toggle: show })}
              onClick={onClick}
            >
              <span className={clsx('icon-bar', { iconTaggle: show })} />
              <span className={clsx('icon-bar', { iconTaggle: show })} />
              <span className={clsx('icon-bar', { iconTaggle: show })} />
            </button>
          </div>
          <div className={clsx('nav-ul')} key='one'>
            <ul className={clsx('ul')}>
              {pageList?.map((v, index) => {
                return (
                  <li key={index}>
                    <Link
                      to={v.path}
                      onClick={() => onLinkClick(v)}
                      className={clsx({
                        active: v.active,
                      })}
                    >
                      {v.name}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
      <QueueAnim
        className={clsx('content')}
        animConfig={[
          { opacity: [1, 0], translateY: [0, -30] },
          { opacity: [1, 0], translateY: [0, -30] },
        ]}
      >
        {show
          ? [
              <div className={clsx('select')} key='one'>
                <ul className={clsx('select-ul')}>
                  {pageList?.map((v, index) => {
                    return (
                      <li key={index}>
                        <Link
                          to={v.path}
                          onClick={onPath}
                          className={clsx({ active: v.active })}
                        >
                          {v.name}
                        </Link>
                      </li>
                    );
                  })}
                </ul>
              </div>,
            ]
          : null}
      </QueueAnim>
    </div>
  );
};

export default Header;
